import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./contexts/AuthContext";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme"; // Make sure this file exists
import "./index.css";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
);

// ✅ Register service worker for PWA
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("✅ Service Worker registered with scope:", registration.scope);

        // Listen for updatefound to detect new SW being installed
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (!newWorker) return;
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed') {
              if (navigator.serviceWorker.controller) {
                // New update available
                console.log('🔔 New content is available; please refresh.');
                // Optionally, broadcast a message or trigger a UI prompt here
              } else {
                // Content cached for offline use
                console.log('📦 Content is cached for offline use.');
              }
            }
          });
        });

      })
      .catch((error) => {
        console.error("❌ Service Worker registration failed:", error);
      });
  });
}
